export const SET_O1_REQUEST = 'SET_O1_REQUEST';
export const SET_O1_FAILED = 'SET_O1_FAILED';
export const SET_O1_OFFERINGS_SUCCESS = 'SET_O1_OFFERINGS_SUCCESS';
export const CLEAN_O1 = 'CLEAN_O1';
